import _ from 'lodash';
import { useSelector } from 'react-redux';
import { contributorsSelector } from 'state/selectors/contributors';
import Text from 'components/base/Text';
import { Flex, Margin } from 'components/base/layout-components';
import SearchableListWithChips from 'components/SearchableListWithChips';
import CollapseSection from '../../../../../components/CollapseSection';
import {
  ChipComponent,
  ListItem
} from '../../../../EmailPreferences/SearchListComponents';
import { StyledFormItem } from './FormItems/FormItems.style';

const TitleComponent = ({ directContributors }) => (
  <Flex>
    <Text size='medium' mr='4rem'>
      Direct Contributors
    </Text>
    <Text size='normal' weight={400} color='shuttleGray' mr='2.5rem'>
      {`${directContributors.length} selected`}
    </Text>
  </Flex>
);

export const formatContributors = (contributors, isDisabled) => {
  const formattedContributors = contributors.filter(Boolean).map(item => ({
    ...item,
    avatarUrl: item?.extended_data?.avatar_url,
    isDisabled,
    view: (
      <ListItem
        key={item.name}
        name={item.name}
        email={item.email}
        avatarUrl={item?.extended_data?.avatar_url}
      />
    )
  }));

  return formattedContributors;
};

const DirectContributorsSelection = ({
  isDirectContributorsCollapsable,
  directContributors,
  setDirectContributors,
  isSynced,
  limit,
  isTitleClickable
}) => {
  const contributors = useSelector(contributorsSelector);
  const isDisabled = !!limit && directContributors.length >= limit;

  return (
    <CollapseSection
      title={isOpen => (
        <TitleComponent directContributors={directContributors} />
      )}
      pl='medium'
      openButtonText='View & edit'
      isCollapsable={isDirectContributorsCollapsable}
      isTitleClickable={isTitleClickable}
    >
      <Margin t='normal' b='small'>
        <StyledFormItem disabled={isSynced}>
          <SearchableListWithChips
            chip={ChipComponent}
            placeholder='Search contributors'
            searchKeys={['name', 'id']}
            items={formatContributors(contributors, isDisabled)}
            onSelectItem={item => {
              setDirectContributors([...directContributors, item]);
            }}
            onRemoveItem={item => {
              setDirectContributors(_.without(directContributors, item));
            }}
            selectedItems={directContributors}
          />
        </StyledFormItem>
      </Margin>
    </CollapseSection>
  );
};
export default DirectContributorsSelection;
